
<main-form-modal (toggleChange)="setVal($event)"> 
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">
           
            <processes-type-edit *ngSwitchCase="true"></processes-type-edit>
            <processes-type-details *ngSwitchCase="false"></processes-type-details>
        </div>
    </ng-template>  
</main-form-modal>